import type { ChangeEvent } from "react"
import EntryFormField, {
  FIELD_CONTROL_CLASS,
} from "@/components/entry/EntryFormField"
import { MIN_ENTRY_PASSWORD_LENGTH } from "@/domain/entry/model/Entry"
import type {
  EntryPasswordErrors,
  EntryPasswordInput,
} from "@/domain/entry/model/Entry"

interface EntryPasswordFieldsProps {
  passwordInput: EntryPasswordInput
  errors: EntryPasswordErrors
  onChange: (field: keyof EntryPasswordInput, value: string) => void
}

/**
 * 신청 비밀번호 입력.
 *
 * 신청 조회 · 수정 · 취소에 연락처와 함께 쓰는 값이라 확인 입력을 나란히 받는다.
 * 분실하면 운영자가 임시 비밀번호를 발급해야 하므로 안내 문구를 함께 둔다.
 */
export default function EntryPasswordFields({
  passwordInput,
  errors,
  onChange,
}: Readonly<EntryPasswordFieldsProps>) {
  function onChangePassword(event: ChangeEvent<HTMLInputElement>) {
    onChange("password", event.target.value)
  }

  function onChangePasswordConfirm(event: ChangeEvent<HTMLInputElement>) {
    onChange("passwordConfirm", event.target.value)
  }

  return (
    <div className="mt-6 grid gap-4 border-t border-app-secondary-300 pt-6 sm:grid-cols-2">
      <EntryFormField
        controlId="entry-password"
        label="신청 비밀번호"
        isRequired
        error={errors.password}
      >
        <input
          id="entry-password"
          type="password"
          autoComplete="new-password"
          value={passwordInput.password}
          maxLength={30}
          onChange={onChangePassword}
          placeholder={`${MIN_ENTRY_PASSWORD_LENGTH}자 이상`}
          aria-invalid={Boolean(errors.password)}
          className={FIELD_CONTROL_CLASS}
        />
      </EntryFormField>

      <EntryFormField
        controlId="entry-password-confirm"
        label="신청 비밀번호 확인"
        isRequired
        error={errors.passwordConfirm}
      >
        <input
          id="entry-password-confirm"
          type="password"
          autoComplete="new-password"
          value={passwordInput.passwordConfirm}
          maxLength={30}
          onChange={onChangePasswordConfirm}
          placeholder="비밀번호를 한 번 더 입력"
          aria-invalid={Boolean(errors.passwordConfirm)}
          className={FIELD_CONTROL_CLASS}
        />
      </EntryFormField>

      <p className="app-field-help sm:col-span-2">
        신청 조회 · 수정 · 취소에 체육관 연락처와 함께 사용합니다. 잊으신 경우
        대회 운영측에 문의하면 임시 비밀번호를 발급받을 수 있습니다.
      </p>
    </div>
  )
}
